/**
 * Personas that act as "brokers": they have clients, see client properties,
 * and get the broker UI (Mes clients, partage avec le courtier, etc.).
 */
export const BROKER_PERSONAS = ['courtier_hypo', 'courtier_immo', 'preteur_prive'];

/** Personas that require admin approval before platform access. */
export const PERSONAS_REQUIRING_APPROVAL = ['courtier_hypo', 'courtier_immo', 'preteur_prive'];

/**
 * Account types shown on signup / onboarding.
 * Only `selectable: true` can be chosen for public signup (v1: investor only).
 * Others remain visible as a "coming soon" teaser.
 */
export const SIGNUP_ACCOUNT_TYPES = [
  { id: 'investisseur', labelKey: 'signup.accountType.investisseur', selectable: true },
  { id: 'courtier_immo', labelKey: 'persona.courtier_immo', selectable: false },
  { id: 'courtier_hypo', labelKey: 'persona.courtier_hypo', selectable: false },
  { id: 'preteur_prive', labelKey: 'persona.preteur_prive', selectable: false },
];

/** Personas that may be selected on public signup / onboarding. */
export const SIGNUP_SELECTABLE_PERSONAS = SIGNUP_ACCOUNT_TYPES.filter((t) => t.selectable).map(
  (t) => t.id,
);

/**
 * @param {string} [persona]
 * @returns {boolean}
 */
export function isSignupPersonaSelectable(persona) {
  return Boolean(persona && SIGNUP_SELECTABLE_PERSONAS.includes(persona));
}

/**
 * @param {string} [persona]
 * @returns {boolean}
 */
export function isBrokerPersona(persona) {
  return Boolean(persona && BROKER_PERSONAS.includes(persona));
}

/**
 * @param {string} [persona]
 * @returns {boolean}
 */
export function requiresPersonaApproval(persona) {
  return Boolean(persona && PERSONAS_REQUIRING_APPROVAL.includes(persona));
}

/**
 * @param {{ persona?: string, personaApprovalStatus?: string } | null | undefined} profile
 * @returns {boolean}
 */
export function isPersonaAccessGranted(profile) {
  if (!profile?.persona) return true;
  if (!requiresPersonaApproval(profile.persona)) return true;
  const status = profile.personaApprovalStatus;
  if (!status || status === 'approved') return true;
  return false;
}

/**
 * @param {{ persona?: string, personaApprovalStatus?: string } | null | undefined} profile
 * @returns {'pending' | 'rejected' | null}
 */
export function getPersonaApprovalBlockReason(profile) {
  if (isPersonaAccessGranted(profile)) return null;
  if (profile?.personaApprovalStatus === 'rejected') return 'rejected';
  return 'pending';
}
